import React, { useEffect, useState } from "react";
import { addMedicareLocation } from "../../../../services/SystemLocationAPI";
import { fetchPickListByGroupName } from "../../../../services/UserRegistrationApi";
import { PICKLIST_GROUP_NAME } from "../../../../common/Constant";
import { normalizeCountry, normalizeState } from "../../../../utils/normalizer";
import AccordionComponent from "../../../../common/Accordion";
import SearchHospitalAutosuggest, { LocationSuggestion } from "../../../../common/SearchHospitalAutosuggest";
import {
  Button,
  Col,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import DataTableAddress from "../../../../common/DataTableAddress";
import DataTable from "../../../../common/DataTable";

import {
  CONTACT_LOG_HEADERS,
  STAKEHOLDER_LOG_ADDRESS,
  STAKEHOLDERS_ADDRESS,
} from "../../../Master/Stakeholders/actions/Constant";
import {
  addStackeholderAddress,
  GetAddressList,
  searchZipCode,
  StachHolderTypes,
  updateStackeholderAddress,
} from "../../../../services/StakeholderApi";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import TextInput from "../../../../common/TextInput";
import FormattedPhoneInput from "../../../../common/FormattedPhoneInput";
import { validateStakeholderAddress } from "../../../Master/Stakeholders/components/stakeholderValidation";
import Snackbar from "../../../../common/Snackbar";
import moment from "moment";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import { isValidCoordinate } from "../../../../utils/validators";

interface Option {
  areaName?: string;
  localeName?: string;
  physicalCity?: string;
  physicalZip?: string;
  physicalState?: string;
  districtName?: string;
  country?: string;
}

interface AddressProps {
  partyID: number;
  setHasAddressData: any;

  onBack: () => void;
}

const AddNewPartyAddress: React.FC<AddressProps> = ({
  partyID,
  setHasAddressData,
  onBack,
}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [addressData, setAddressData] = useState<any[]>([]); // <-- Add state for contact dat
  const [showForm, setShowForm] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [partyAddressID, setPartyAddressID] = useState<number | null>(null);
  const [addressOptions, setAddressOptions] = useState<any[]>([]);
  const [addressType, setAddressType] = useState("");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [suggestionSelected, setSuggestionSelected] = useState(false);
  const [suggestionFilled, setSuggestionFilled] = useState({ city: false, state: false, country: false, zip: false });
  const [addressDetails, setAddressDetails] = useState({
    city: "",
    state: "",
    country: "",
    zip: "",
  });

  const [addressline1, setAddressLine1] = useState("");
  const [addressline2, setAddressLine2] = useState("");
  const [addressline3, setAddressLine3] = useState("");

  const [faxNumber, setFaxNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [isPrimary, setIsPrimaryAddress] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [comments, setComments] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");

  const [selectedAddress, setSeletectedAddress] = useState<any>(null);
  const [addressLogDetails, setAddressLogDetails] = useState<any[]>([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [pendingGoogleLocation, setPendingGoogleLocation] = useState<any>(null);
  const [instructionOption, setInstructionOption] = useState<
    { value: string; label: string }[]
  >([]);

   const fetchInstructionOptions = async () => {
    try {
      const data = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Location_SplInstructions,
        triggerById: loggedInUserid,
      });
      setInstructionOption(data || []);
    } catch (error) {
      console.error("Error fetching instruction options:", error);
    }
  };

  useEffect(() => {
    const fetchDropdownOptions = async () => {
      try {
        const response = await StachHolderTypes({
          groupName: "Address_Type",
          triggerById: Number(loggedInUserid),
        });
        const formattedOptions = response.result.map((item: any) => ({
          value: String(item.pickListItemId),
          label: item.displayName,
        }));
        setAddressOptions(formattedOptions);
        const defaultOption = formattedOptions.find(
          (item) =>
            item.label.toLowerCase() === "Commercial/Business".toLowerCase()
        );

        if (defaultOption) {
          setAddressType(defaultOption.value);
        }
      } catch (error) {
        console.error("Error fetching stakeholder types:", error);
      }
    };

    fetchDropdownOptions();
    fetchInstructionOptions();
  }, [loggedInUserid]);

  const handleSuggestionSelect = (suggestion: LocationSuggestion) => {
    const newStateCode = suggestion.physicalStateCode || normalizeState(suggestion.physicalState || "");
    const newCountryCode = normalizeCountry(suggestion.country || "USA");

    if (suggestion.source === "google") {
      setPendingGoogleLocation({
        source: "google",
        providerName: suggestion.providerName,
        providerAddress: suggestion.providerAddress,
        physicalCity: suggestion.physicalCity,
        physicalState: newStateCode,
        physicalZip: suggestion.physicalZip,
        countryName: newCountryCode,
        county: suggestion.county,
        areaName: suggestion.areaName || "",
        latitude: isValidCoordinate(suggestion.latitude) ? String(suggestion.latitude) : "",
        longitude: isValidCoordinate(suggestion.longitude) ? String(suggestion.longitude) : "",
      });
    } else {
      setPendingGoogleLocation(null);
    }
    setSuggestionSelected(true);
    setSuggestionFilled({
      city: !!suggestion.physicalCity,
      state: !!newStateCode,
      country: !!newCountryCode,
      zip: !!suggestion.physicalZip,
    });
    setAddressDetails({
      city: suggestion.physicalCity || "",
      state: newStateCode,
      country: newCountryCode || "USA",
      zip: suggestion.physicalZip || "",
    });
    setAddressLine1(suggestion.providerAddress || suggestion.providerName || "");
  };

  const fetchAddressData = async () => {
    try {
      const data = await GetAddressList(partyID);
      setAddressData(data || []); // <-- Update contactData state
      setHasAddressData((data || []).length > 0);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchAddressData();
  }, [partyID]);

  const validatePartyAddress = () => {
    // Prepare values to pass for validation
    const validationErrors = validateStakeholderAddress(
      addressType,
      addressDetails,
      addressline1,
      phoneNumber,
      faxNumber
    );

    // Call the validation function

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n")); // Show error messages directly
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSaveAddress = async () => {
    if (isSaving) return;
    if (validatePartyAddress()) {
      try {
        setIsSaving(true);
        if (pendingGoogleLocation?.source === "google") {
          const locationResult = await addMedicareLocation({
            medicareId: 0,
            providerName: pendingGoogleLocation.providerName || searchQuery,
            providerAddress: addressline1 || pendingGoogleLocation.providerAddress,
            physicalCity: addressDetails?.city || pendingGoogleLocation.physicalCity || "",
            physicalState: addressDetails?.state || pendingGoogleLocation.physicalState || "",
            physicalZip: addressDetails?.zip || pendingGoogleLocation.physicalZip || "",
            countryName: addressDetails?.country || pendingGoogleLocation.countryName || "USA",
            providerType: "Medicare",
            latitude: pendingGoogleLocation.latitude,
            longitude: pendingGoogleLocation.longitude,
            county: pendingGoogleLocation.county,
            telephoneNumber: "",
            faxNumber: "",
            emailId: "",
            splInstructions: instructionOption.map((opt: any) => ({
              SplInstructionID: opt.value,
              SplInstructionData: "",
            })),
            contactName: "",
            regionId: null,
            createdBy: loggedInUserid,
          }).catch((err: any) => { console.error("Failed to save Google location:", err); return null; });
          setPendingGoogleLocation(null);
        }
        const addressPayload = {
          stakeholderId: partyID,
          stakeholderAddressId: partyAddressID ? partyAddressID : null,
          addressTypeId: addressType,
          addressLine1: addressline1,
          addressLine2: addressline2,
          addressLine3: addressline3,
          city: addressDetails.city,
          state: addressDetails.state,
          zipCode: addressDetails.zip,
          country: addressDetails.country,
          county: addressDetails.country,
          phoneNumber: phoneNumber,
          faxNumber: faxNumber,
          isPrimary: isPrimary == true ? 1 : 0,
          comments: comments,
          isActive: isActive == true ? 1 : 0,
        };

        const isUpdate = partyAddressID ? true : false;

        const apiMethod = isUpdate
          ? updateStackeholderAddress
          : addStackeholderAddress;

        const response = await apiMethod(addressPayload);

        if (response.result.responseCode == 2) {
          setSnackbarMessage("Only one primary address is allowed!");
          setSnackbarOpen(true);
          setError("error");
        } else {
          setSnackbarMessage("Address saved successfully!");
          setSnackbarOpen(true);
          setError("success");
          setShowForm(false);
          setAddressFormSubKey(null);
          setSearchQuery("");
          setAddressListKey("0");
          fetchAddressData();
        }
      } catch {
        setSnackbarMessage(
          "An error occurred while saving address details. Please try again."
        );
        setError("error");
        setSnackbarOpen(true);
      } finally {
        setIsSaving(false);
      }
    }
  };

  const handleAddAddress = () => {
    setShowForm(true);
    fetchAddressData();
    setAddressFormSubKey("0");
    setAddressListKey(null);
    setSeletectedAddress(null);
    setPartyAddressID(null);
    // setAddressType("");
    setAddressLine1("");
    setAddressLine2("");
    setAddressLine3("");
    setPhoneNumber("");
    setFaxNumber("");
    setIsPrimaryAddress(false);
    setIsActive(true);
    setComments("");
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, state: false, country: false, zip: false });
    setPendingGoogleLocation(null);
    setAddressDetails({
      city: "",
      state: "",
      country: "",
      zip: "",
    });

    setSearchQuery("");
  };

  const editAddress = (actionType: string, address: any) => {
    setShowForm(true);
    setAddressFormSubKey("0");
    setAddressListKey(null);
    setSeletectedAddress(address);
    setPartyAddressID(address.stakeholderaddressid);

    setAddressType(String(address.addresstypeid));
    setAddressLine1(address.addressline1);
    setAddressLine2(address.addressline2);
    setAddressLine3(address.addressline3);
    setPhoneNumber(address.phonenumber);
    setFaxNumber(address.faxnumber);
    setIsPrimaryAddress(address.isprimaryaddress);
    setIsActive(address.isactive);
    setComments(address.comments);
    setAddressDetails({
      city: address.city,
      state: address.state,
      country: address.country,
      zip: address.zipcode,
    });

  };

  const handleCancel = () => {
    setShowModal(true); // Show confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close modal without resetting form
  };

  const handleConfirmCancel = () => {
    setShowForm(false);
    setShowModal(false);
    setAddressFormSubKey(null);
    setSeletectedAddress(null);
    setAddressListKey("0");
    setPartyAddressID(null);
    setAddressType("");
    setAddressLine1("");
    setAddressLine2("");
    setAddressLine3("");
    setPhoneNumber("");
    setFaxNumber("");
    setIsPrimaryAddress(false);
    setIsActive(false);
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, state: false, country: false, zip: false });
    setPendingGoogleLocation(null);
    setAddressDetails({
      city: "",
      state: "",
      country: "",
      zip: "",
    });

    setSearchQuery("");
    // Close modal after confirmation
  };

  const [addressListKey, setAddressListKey] = useState<string | null>("0");

  const addressDetailSubAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={addressListKey}
      onSelect={(key) => setAddressListKey(key as string)}
    />
  );

  const [addressFormSubKey, setAddressFormSubKey] = useState<string | null>(
    null
  );

  const addressFormSubAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={addressFormSubKey}
      onSelect={(key) => setAddressFormSubKey(key as string)}
    />
  );

  const [addressDetailKey, setaddressDetailKey] = useState<string | null>("0");

  const addressDetailAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={addressDetailKey}
      onSelect={(key) => setaddressDetailKey(key as string)}
    />
  );

  const [communicationDetailKey, setcommunicationDetailKey] = useState<
    string | null
  >("0");

  const communicationDetailAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={communicationDetailKey}
      onSelect={(key) => setcommunicationDetailKey(key as string)}
    />
  );

  const handlePDFClick = () => {
    if (selectedAddress) {
      // Extract the four fields from the selectedContact

      const { createdbyname, createddate, modifiedbyname, modifieddate } =
        selectedAddress;

      // Format the date using moment.js
      const formattedCreatedDate =
        moment(createddate).format("MM/DD/YYYY HH:mm");
      const formattedModifiedDate =
        moment(modifieddate).format("MM/DD/YYYY HH:mm");

      // Set the values in the state
      setAddressLogDetails([
        {
          createdbyname,
          createddate: formattedCreatedDate, // Use formatted date
          modifiedbyname,
          modifieddate: formattedModifiedDate, // Use formatted date
        },
      ]);

      // Show the drawer
      setShowDrawer(true);
    }
  };
  const handleCloseDrawer = () => {
    setShowDrawer(false);
  };

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
      {showForm &&
        addressFormSubAccordion([
          {
            title: "Address Details",
            content: (
              <>
                {addressDetailAccordion([
                  {
                    title: "Details",
                    content: (
                      <>
                        <Row className="row mb-3">
                          {/* <Col
                            md={3}
                            className="selection_dropdown adj_label_lt"
                          >
                            <SearchableSingleSelectDropdown
                              label="Address Type"
                              name="AddressTypeID"
                              required
                              options={addressOptions}
                              value={addressType} // Keep it a string if required
                              onChange={(e) => setAddressType(e.target.value)}
                            />
                          </Col> */}

                          <Col md={12}>
                            <SearchHospitalAutosuggest
                              value={searchQuery}
                              onChange={setSearchQuery}
                              onSuggestionSelect={handleSuggestionSelect}
                              label="Search Address"
                              maxLength={50}
                            />
                          </Col>
                        </Row>

                        <Row className="row mb-2">
                          <Col md={6}>
                            <TextInput
                              label="Address Line 1"
                              name="AddressLine1"
                              value={addressline1}
                              required
                              maxLength={100}
                              onChange={(e) => setAddressLine1(e.target.value)}
                            />
                          </Col>
                          <Col md={6}>
                            <TextInput
                              name="AddressLine2"
                              label="Address Line 2"
                              value={addressline2}
                              maxLength={100}
                              onChange={(e) => setAddressLine2(e.target.value)}
                            />
                          </Col>
                        </Row>
                        <Row className="row mb-3 mt-3">
                          <Col md={6}>
                            <TextInput
                              name="AddressLine3"
                              label="Address Line 3"
                              value={addressline3}
                              maxLength={100}
                              onChange={(e) => setAddressLine3(e.target.value)}
                            />
                          </Col>
                        </Row>
                        <Row className="row mb-3">
                          {["City", "State", "Country", "Zip"].map((field) => {
                            const value =
                              addressDetails[
                                field.toLowerCase() as keyof typeof addressDetails
                              ];

                            const isDisabled = !suggestionSelected || !!suggestionFilled[field.toLowerCase() as keyof typeof suggestionFilled];
                            return (
                              <Col md={3} key={field}>
                                <TextInput
                                  label={field}
                                  name={field}
                                  value={value}
                                  maxLength={field === "State" && !isDisabled ? 3 : field === "Zip" && !isDisabled ? 10 : 100}
                                  required
                                  onChange={(e) => {
                                    const newValue = field === "Zip" ? e.target.value.replace(/\D/g, "") : e.target.value;
                                    setAddressDetails((prev: any) => ({ ...prev, [field.toLowerCase()]: newValue }));
                                  }}
                                  disabled={isDisabled}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      </>
                    ),
                  },
                ])}
                {communicationDetailAccordion([
                  {
                    title: "Communication Details",
                    content: (
                      <>
                        <Row className="mb-3">
                          <div className="col-md-3  mb-3">
                            <FormattedPhoneInput
                              label="Phone Number"
                              name="Phonenumber"
                              value={phoneNumber}
                              onChange={setPhoneNumber}
                              required
                            />
                          </div>
                          <div className="col-md-3  mb-3 ">
                            <FormattedPhoneInput
                              label="Fax No"
                              name="Faxnumber"
                              value={faxNumber}
                              onChange={setFaxNumber}
                            />
                          </div>
                          <div className="col-6"></div>
                          <div className="mt-1 mb-3">
                            <label htmlFor="isActive" className="me-2 fw-bold">
                              Is PrimaryAddress
                            </label>
                            <input
                              type="checkbox"
                              checked={isPrimary}
                              onChange={(e) =>
                                setIsPrimaryAddress(e.target.checked)
                              }
                              className="me-2"
                            />
                            {isPrimary ? <span>Yes</span> : <span>No</span>}
                          </div>
                          <div className="col-md-12 mb-3">
                            <TextInput
                              name="Comments"
                              label="Comments"
                              value={comments}
                              maxLength={100}
                              onChange={(e) => setComments(e.target.value)}
                            />
                          </div>
                          <div className="mt-3">
                            <label htmlFor="isActive" className="me-2 fw-bold">
                              Is Active
                            </label>
                            <input
                              type="checkbox"
                              id="isActive"
                              checked={isActive}
                              onChange={(e) => setIsActive(e.target.checked)}
                              className="me-2"
                            />
                            {isActive ? <span>Yes</span> : <span>No</span>}
                          </div>
                        </Row>
                      </>
                    ),
                  },
                ])}
                <Row className="mt-3">
                  <Col sm={6} className="d-flex justify-content-start">
                    {" "}
                    {partyAddressID ? (
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                            Logs
                          </Tooltip>
                        }
                      >
                        <div className="d-flex">
                          <Button
                            type="button"
                            className="btn btn-primary d-flex align-items-center mx-2"
                            onClick={handlePDFClick}
                          >
                            <span className="material-icons">description</span>
                          </Button>
                        </div>
                      </OverlayTrigger>
                    ) : null}
                    <Button
                      variant="outline"
                      className="btn d-flex align-items-center btn-text-border"
                      onClick={handleConfirmCancel}
                    >
                      <span className="material-icons me-1">arrow_back</span>
                      Back
                    </Button>
                  </Col>

                  <Col className="d-flex justify-content-end mb-2">
                    <Button
                      variant="outline-info"
                      className="d-flex align-items-center"
                      onClick={handleCancel}
                    >
                      <span className="material-icons mr-2">close</span>Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="ms-3 d-flex align-items-center"
                      onClick={handleSaveAddress}
                      disabled={isSaving}
                    >
                      <span className="material-icons mx-1">save</span>Save
                    </Button>
                  </Col>
                </Row>
                <OverlayDrawer
                  title={"Logs"}
                  open={showDrawer}
                  onClose={handleCloseDrawer}
                  placement="bottom"
                >
                  <DataTable
                    headers={CONTACT_LOG_HEADERS}
                    rows={addressLogDetails}
                    isLogTable={true}
                  />
                </OverlayDrawer>
              </>
            ),
          },
        ])}

      <Modal show={showModal} onHide={handleCloseModal}>
        {/* <Modal.Header closeButton>
            <Modal.Title>Confirm Cancellation</Modal.Title>
          </Modal.Header> */}
        <Modal.Body className="fw-bold text-left modelheading">
          <div>Are you sure you want to cancel the form?</div>
          <div style={{ fontWeight: "300" }}>
            {" "}
            Any unsaved data will be lost.
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end bg-light ">
          <Button
            variant="outline-info"
            className="d-flex align-items-center"
            onClick={handleCloseModal}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={handleConfirmCancel}
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      {!showForm && (
        <>
          {addressDetailSubAccordion([
            {
              title: "Address List",
              content: (
                <>
                  <div className="d-flex justify-content-between align-items-center border-bottom pb-1 px-0 cancelappointment col mb-3">
                    <h3 className="mr-2 me-auto">List</h3>
                    <div className="address_cta_pos_relative mt-1">
                      <div className="container-fluid">
                        <div className="hstack gap-2">
                          <Button
                            className="btn btn-primary d-flex align-items-center"
                            onClick={handleAddAddress}
                            style={{ float: "right" }}
                          >
                            <span className="material-icons me-2">add</span>
                            Add
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <DataTableAddress
                    headers={STAKEHOLDERS_ADDRESS}
                    rows={addressData}
                    onAction={editAddress}
                  />
                </>
              ),
            },
          ])}

          <Row>
            <Col md={6} className="d-flex justify-content-start">
              <Button
                variant="outline"
                className="btn d-flex align-items-center btn-text-border"
                onClick={onBack}
              >
                <span className="material-icons me-1">arrow_back</span>
                Back
              </Button>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default AddNewPartyAddress;
